<template>
    <v-navigation-drawer tag="nav" fixed temporary v-model="mobileMenuDrawer">
        <v-list nav dense expand class="mobile">
            <div v-for="(item, i) in items" :key="i">
                <v-list-item
                    dense
                    v-if="!item.subItems"
                    :to="item.link"
                    class="pl-11"
                    :class="[item.link === $route.name ? 'v-item--active v-list-item--active' : '']"
                    @click="clear"
                    style="min-height: 32px !important"
                >
                    <v-list-item-title
                        class="font-weight-medium pt-2"
                        style="line-height: 2rem; min-height: 32px !important"
                        :class="[item.link === $route.name ? 'tbgreen-text' : $vuetify.theme.dark ? 'whiteText' : 'blackText']"
                    >
                        {{ $t('menu.' + item.title) }}
                    </v-list-item-title>
                </v-list-item>
                <v-list-group class="m-menu" v-else :key="i" no-action :value="item.title === $route.meta.menu && item.title !== 'tools'">
                    <template v-slot:activator>
                        <v-list-item-title
                            class="font-weight-medium pt-1"
                            style="line-height: 2rem; min-height: 32px !important"
                            :class="[
                                item.title === $route.meta.menu && $route.name !== 'bot' ? 'tbgreen-text' : $vuetify.theme.dark ? 'whiteText' : 'blackText',
                            ]"
                        >
                            <v-icon :color="item.title === $route.meta.menu && $route.name !== 'bot' ? 'tbGreen' : '#7a7a7a'" style="margin-right: 10px">
                                {{ item.icon }}
                            </v-icon>
                            {{ $t('menu.' + item.title) }}
                        </v-list-item-title>
                    </template>

                    <v-list-item-group :key="item.title" v-model="selection[item.title]">
                        <v-list v-if="item.subItems" class="py-0 rounded">
                            <div v-for="subItem in item.subItems" :key="subItem.title" class="pb-1">
                                <v-subheader
                                    v-if="!subItem.link"
                                    :class="$vuetify.theme.dark ? 'whiteText' : 'blackText'"
                                    class="pl-11 font-weight-black font11 text-uppercase"
                                    style="height: 30px"
                                >
                                    {{ $t('menu.' + subItem.title) }}
                                </v-subheader>
                                <router-link
                                    v-else
                                    :to="{
                                        name: subItem.link,
                                        params: subItem.params ? subItem.params : {},
                                    }"
                                >
                                    <v-list-item
                                        dense
                                        style="min-height: 32px"
                                        class="pl-11"
                                        :class="[subItem.link === $route.name ? 'v-item--active v-list-item--active' : '']"
                                        @click="clear"
                                    >
                                        <v-list-item-content>
                                            <v-list-item-title
                                                class="font-weight-medium"
                                                :class="[subItem.link === $route.name ? 'tbgreen-text' : $vuetify.theme.dark ? 'whiteText' : 'blackText']"
                                                style="line-height: 2rem"
                                            >
                                                <v-icon v-if="subItem.icon" :color="subItem.iconColor" size="20px">
                                                    {{ subItem.icon }}
                                                </v-icon>
                                                {{ $t('menu.' + subItem.title) }}
                                            </v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </router-link>
                                <v-divider v-if="subItem.divider" class="mt-1 ml-11"></v-divider>
                            </div>
                        </v-list>
                    </v-list-item-group>
                </v-list-group>
            </div>
        </v-list>
    </v-navigation-drawer>
</template>
<style scoped></style>
<script>
    export default {
        name: 'app-menuMobile',

        props: {
            items: [],
        },

        data() {
            return {
                selection: [],
            };
        },

        created() {
            console.log('Component %s was created.', this.$options.name);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {
            clear() {
                this.selection = [];
            },
        },

        computed: {
            mobileMenuDrawer: {
                get() {
                    return this.$store.getters['MenuModule/getMobileMenuDrawer'];
                },
                set(value) {
                    this.$store.commit('MenuModule/setMobileMenuDrawer', value);
                },
            },
        },
    };
</script>
